import styled from 'styled-components';

export const StyledDefaultButton = styled.button`
  display: ${props => (props.type === 'block' ? 'block' : 'inline-block')};
  position: relative;
  padding: 0 16px;
  min-height: 30px;
  line-height: 30px;
  min-width: ${props => (props.type === 'icon' ? '30px' : '88px')};
  border-radius: ${props => props.theme.borders.radius};
  border: none;
  font-size: ${props => props.theme.fonts.defaultSize};
  cursor: pointer;
  text-align: center;
  text-decoration: none;
  outline: none;
  font-family: mm-main, arial, sans-serif;

  &:visited,
  &:active {
    color: inherit;
  }

  background-color: ${props =>
    props.type === 'icon' ? 'transparent' : props.theme.colors.white};

  &:hover {
    outline: none;
    background-color: ${props =>
      props.type === 'icon' ? 'transparent' : props.theme.colors.grey};
  }
`;

export const StyledPrimaryButton = styled(StyledDefaultButton)`
  color: ${props => props.theme.colors.white};
  background-color: ${props => props.theme.colors.primary};

  &:hover {
    background-color: ${props => props.theme.colors.primaryDark};
  }
`;

export const StyledSecondaryButton = styled(StyledDefaultButton)`
  color: ${props => props.theme.colors.white};
  background-image: linear-gradient(
    90deg,
    hsla(0, 0%, 100%, 0),
    ${props => props.theme.colors.secondary}
  );
  background-color: ${props => props.theme.colors.secondaryGradient};

  &:hover {
    background-color: ${props => props.theme.colors.secondaryDark};
  }
`;

export const StyledTransparentButton = styled(StyledDefaultButton)`
  background-color: transparent;

  &:hover {
    background-color: transparent;
  }
`;
